import { useState } from 'react';

import { trans } from '@spotahome/soyuz/client';

import Section from '@spotahome/landings-common/src/components/LandingSection';

import { HOW_IT_WORKS_STEPS } from '../../constants/howItWorks';

import HiwStepItemCollapsible from './HiwStepItemCollapsible';

import './HiwStepsMobile.scss';

const HiwStepsMobile = () => {
  const [indexOpened, setIndexOpened] = useState(0);

  const handleCollapseChange = (collapsed, index) => {
    setIndexOpened(collapsed ? null : index);
  };

  return (
    <Section className="hiw-steps-mobile">
      <h2 className="hiw-steps-mobile__title">
        {trans('how_it_works.steps.title')}
      </h2>
      {HOW_IT_WORKS_STEPS.map(
        (
          { titleKey, descriptionKey, bulletPoints, renderImage, cta },
          index
        ) => (
          <HiwStepItemCollapsible
            stepNumber={index + 1}
            key={titleKey}
            titleKey={titleKey}
            descriptionKey={descriptionKey}
            bulletPoints={bulletPoints}
            renderImage={renderImage}
            cta={cta}
            isCollapsed={indexOpened !== index}
            onCollapsedChange={collapsed =>
              handleCollapseChange(collapsed, index)
            }
          />
        )
      )}
    </Section>
  );
};

export default HiwStepsMobile;
